// Dependencies
require("webstrap/type");
require("grid");
require("section/generic");
require("element/rich-text");
require("element/liste");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/liste/index.js
 ** module id = 157
 ** module chunks = 0 1
 **/